module.exports=function(scope){ return `{
    "data": {
        "sourceFaceMap": {
            "glasses": false,
            "sessionTokenStatus": 0,
            "faceMapType": 0,
            "livenessStatus": 0,
            "auditTrailVerificationCheck": 1,
            "isLowQuality": false,
            "isReplayFaceMap": true,
            "auditTrailMatchCheck": 1
        },
        "matchLevel": 10,
        "targetFaceMap": {
            "glasses": false,
            "sessionTokenStatus": 2,
            "faceMapType": 0,
            "livenessStatus": 0,
            "auditTrailVerificationCheck": 1,
            "isLowQuality": false,
            "isReplayFaceMap": true,
            "auditTrailMatchCheck": 1
        }
    },
    "meta": {
        "code": 200,
        "message": "The match request was processed and the Match Level was 10",
        "ok": true,
        "m": {
            "targetPrepareAndUpdateTimeInMS": ...,
            "matchTimeInMS": ...,
            "totalDurationInMS": ...,
            "sourcePrepareAndUpdateTimeInMS": ...
        }
    }
}`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/response/success/compare.json.tpl